import { LinearProgress, withStyles } from '@material-ui/core';

const BorderLinearProgress = withStyles((theme) => ({
	root: {
	  height: 10,
	  borderRadius: 5,
	},
	colorPrimary: {
	  backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
	},
	bar: {
	  borderRadius: 5,
	  backgroundColor: '#1a90ff',
	},
  }))(LinearProgress);

export default BorderLinearProgress
